import { Task, TaskConcurrency } from './task'

export default {
  data () {
    if (this.$options.tasks) {
      const tasks = Object.keys(this.$options.tasks).reduce((acc, key) => {
        const val = this.$options.tasks[key]
        const [task, concurrencyType] = (() => {
          const isTaskObject = (typeof val === 'object') && (typeof val.task === 'function')
          if (isTaskObject) {
            return [val.task, val.concurrencyType || TaskConcurrency.default]
          } else {
            return [val, TaskConcurrency.default]
          }
        })()

        acc[key] = new Task(task.bind(this), concurrencyType)
        return acc
      }, {})

      return {
        ...tasks
      }
    }
    return {}
  }
}



// WEBPACK FOOTER //
// ./src/services/task/mixin.js